export const siteInfo = {
  name: "黑料显微镜",
  shortName: "显微镜",
  slogan: "起底网暴黑料 · 追踪键盘侠与水军",
  description:
    "把每一起网暴黑料当作样本，逐层拆解施暴者的动机、键盘侠的行为模式、水军的接单链路与舆论操纵的手法，直到看清热度背后到底是谁在用力。",
  email: "contact@hlxwj-cn.com",
  tipEmail: "tips@hlxwj-cn.com",
  workTime: "工作日 10:00 - 18:00（法定节假日除外）",
  replyNote: "我们通常会在 2 个工作日内回复读者来信与投稿线索。",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "调查档案", to: "/cases" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "联系我们", to: "/contact" },
];

export const heroAnchors = [
  { label: "核心议题", href: "#issues" },
  { label: "数据一览", href: "#numbers" },
  { label: "热门档案", href: "#hot-cases" },
  { label: "主题分类", href: "#topics" },
  { label: "常见问题", href: "#faq" },
];

export const siteStats = [
  { value: "128", unit: "份", label: "已拆解调查档案", note: "涵盖公开报道、平台通报与法院公开文书" },
  { value: "46", unit: "起", label: "典型事件复盘", note: "从发酵到平息的全过程时间线还原" },
  { value: "3200", unit: "+", label: "条话术样本", note: "归纳刷屏文案、带节奏话术与伪装策略" },
  { value: "9", unit: "类", label: "施暴者动机模型", note: "从情绪宣泄到有组织牟利的分类框架" },
];

export const methodSteps = [
  {
    step: "01",
    title: "信息溯源",
    desc: "先把一条黑料还原成可核验的时间线：首发账号、扩散节点、关键转折点，区分事实、情绪与二手转述。",
    icon: "ri-node-tree",
  },
  {
    step: "02",
    title: "动机建模",
    desc: "给每个施暴者归类：是情绪宣泄、从众跟风、流量牟利，还是被组织调度。动机不同，应对方式完全不同。",
    icon: "ri-brain-line",
  },
  {
    step: "03",
    title: "链路还原",
    desc: "顺着账号的注册时间、发文节奏、内容相似度和互动特征，判断是自然人还是批量操作的账号矩阵。",
    icon: "ri-links-line",
  },
  {
    step: "04",
    title: "边界与对策",
    desc: "明确哪些行为已经越过法律边界，需要固定什么证据、通过什么渠道维权，以及如何把伤害降到最低。",
    icon: "ri-shield-check-line",
  },
];

export const categories = [
  {
    slug: "perpetrator",
    name: "施暴者画像",
    desc: "从匿名账号回到真实的人，拆解动机、心理结构与行为模式。",
    icon: "ri-user-search-line",
  },
  {
    slug: "water-army",
    name: "水军产业",
    desc: "报价单、养号、派单与结算，网暴背后的完整生意链条。",
    icon: "ri-group-2-line",
  },
  {
    slug: "manipulation",
    name: "舆论操纵",
    desc: "谁在设局、谁在带节奏、谁在借别人的手完成攻击。",
    icon: "ri-plant-line",
  },
  {
    slug: "platform",
    name: "平台生态",
    desc: "热度机制与推荐算法如何把零星愤怒放大成风暴。",
    icon: "ri-radar-line",
  },
  {
    slug: "law",
    name: "法律边界",
    desc: "从民事侵权到刑事追责，取证要点与维权路径。",
    icon: "ri-scales-3-line",
  },
  {
    slug: "recovery",
    name: "受害者重建",
    desc: "取证、止损、心理重建与重新回到日常的实操指南。",
    icon: "ri-heart-pulse-line",
  },
];

export const testimonials = [
  {
    name: "林一舟",
    role: "被网暴后选择维权的当事人",
    quote:
      "最有用的是那份取证清单。我照着把截图、链接、发布时间一层层整理好，律师说材料比他自己整理的还清楚。",
  },
  {
    name: "夜航船",
    role: "内容审核从业者",
    quote:
      "你们讲账号矩阵的判断方式很实在，不是喊口号。我把其中关于发文节奏的部分改成了内部培训材料。",
  },
  {
    name: "苏晚",
    role: "长期关注舆论议题的读者",
    quote:
      "第一次看到有人把网暴当成一门生意来讲，报价、派单、结算都摊开来说，看完对整个生态的理解完全不一样了。",
  },
  {
    name: "老周",
    role: "中学心理老师",
    quote:
      "把施暴者分成几种心理原型这一篇，我拿去给学生讲了一节课。孩子能听懂，也知道自己随手一句会伤到谁。",
  },
];

export const faqs = [
  {
    q: "黑料显微镜是一个传播八卦的平台吗？",
    a: "不是。我们不做未经核实的隐私曝光，也不站队骂人。我们关注的是机制：网暴黑料是怎么被制造出来的、谁在推动、背后有什么动机和利益，以及普通人该如何自保和维权。文章里出现的信息都来自公开报道、平台通报或法院公开文书。",
  },
  {
    q: "为什么你们要花这么大力气去分析施暴者？",
    a: "因为只指责施暴者并不能阻止下一次网暴。搞清楚动机类型，才能分清哪些人只是情绪上头、哪些人是被组织调度、哪些人靠这个赚钱。对待不同的人，平台处置、法律追责和舆论呼吁的方式都应当不一样。",
  },
  {
    q: "键盘侠和水军是一回事吗？",
    a: "不是。键盘侠通常指自发跟风、情绪驱动的普通网民，他们可能只是被情绪带着走。水军则是收钱办事、按任务输出的账号，行为有明确的目的性和组织特征。两者常常混在同一个评论区里，看起来声势浩大，实际构成完全不同。",
  },
  {
    q: "普通网友能做什么，才不会成为帮凶？",
    a: "最简单也最有效的三条：不清楚来龙去脉之前不转发、不参与人肉、不对当事人做道德审判。如果你发现某个话题下大量账号文案高度雷同、发布时间密集，基本可以判断存在组织化操作，此时沉默和克制就是最好的选择。",
  },
  {
    q: "我被人网暴了，第一步应该做什么？",
    a: "先取证，再止损，最后维权。取证要趁内容还在的时候完成：页面链接、发布时间、账号信息、内容截图和录屏，最好一并保留。止损包括关闭陌生人私信、暂停评论权限、必要时暂时离开社交平台。维权可以走平台举报、报警和民事诉讼三条路径，具体选择取决于行为的严重程度。",
  },
  {
    q: "平台举报通常需要准备哪些材料？",
    a: "建议准备一份按时间排序的证据清单，包含每条内容的链接、发布时间、发布账号、内容形式和你的受损说明。如果是批量账号攻击，把账号列表单独整理成一页，并标注你判断其为组织化操作的依据，例如文案雷同、发文时间集中、账号资料空心化。",
  },
  {
    q: "网暴到什么程度会涉及法律责任？",
    a: "侮辱、诽谤、侵犯隐私和个人信息等行为，可能同时构成民事侵权和治安违法，情节严重的还可能触犯刑法。判断关键在于内容的虚假程度、传播范围、持续时间以及对当事人造成的实际损害。具体情况差异很大，建议尽早咨询专业律师。",
  },
  {
    q: "我可以向你们提供线索吗？",
    a: "可以。我们接受读者投稿和线索，但只对能够提供公开可核验材料的事件展开分析，不接受匿名指控具体个人。发送线索时请附上原始链接与时间信息，我们会先做一轮核实，再决定是否立项。",
  },
];